require('./index.scss')

module.exports =
  template: require('./index.pug')()
  controller: require('./index.ctrl')
